import DOMPurify from 'dompurify';

// Configure DOMPurify with a strict whitelist of allowed tags
const ALLOWED_TAGS = ['b', 'i', 'em', 'strong', 'a', 'p', 'br', 'ul', 'ol', 'li'];
const ALLOWED_ATTR = ['href', 'target', 'title'];

const config = {
  ALLOWED_TAGS,
  ALLOWED_ATTR,
  KEEP_CONTENT: true,
};

/**
 * Sanitize HTML content to prevent XSS attacks.
 * Removes dangerous tags and attributes, keeps safe formatting.
 */
export const sanitizeHtml = (dirty: string): string => {
  if (!dirty || typeof dirty !== 'string') return '';
  return DOMPurify.sanitize(dirty, config);
};

/**
 * Sanitize plain text — strips all HTML tags.
 * Use this for user names, emails, and other text-only fields.
 */
export const sanitizeText = (text: string): string => {
  if (!text || typeof text !== 'string') return '';
  return DOMPurify.sanitize(text, { ALLOWED_TAGS: [] });
};

/**
 * Escape HTML special characters for safe rendering in plain text contexts.
 * Use when you need to display user input as literal text (not HTML).
 */
export const escapeHtml = (text: string): string => {
  if (!text || typeof text !== 'string') return '';
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
};
